// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetLocationsApiParameter } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";

export const getGeoCurrentLocation = (defaultLocation: GetLocationsApiParameter) =>
    new Promise<GetLocationsApiParameter>((resolve, _) => {
        if (!navigator.geolocation) {
            resolve(defaultLocation);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position: GeolocationPosition) => {
                resolve({
                    latitude: parseFloat(`${position.coords.latitude}`),
                    longitude: parseFloat(`${position.coords.longitude}`),
                });
            },
            (_: any) => {
                resolve(defaultLocation);
            },
            { timeout: 5500 },
        );
    });
